import { UpsertScheduleQualificationModalInterface } from "../UpsertScheduleQualificationModalSlice";

interface Args {
    formValues?: UpsertScheduleQualificationModalInterface["formValues"];
    isEstablishmentManager: boolean;
}

export const deriveIsSubmitDisabled = (args: Args): boolean => {
    const { formValues, isEstablishmentManager } = args;
    if (!formValues) return true;

    const hasEmployee = Boolean(formValues.employee?.value);
    const hasEducator = Boolean(formValues.educator?.value);
    const hasQualification = Boolean(formValues.qualification?.value);
    const hasStart = Boolean(formValues.startDate);
    const hasEnd = Boolean(formValues.endDate);

    if (isEstablishmentManager && !hasEmployee) return true;
    if (!hasEducator || !hasQualification || !hasStart || !hasEnd) return true;

    // Optional: basic date order validation (do not block if parsing fails)
    try {
        if (formValues.startDate && formValues.endDate) {
            const start = new Date(formValues.startDate);
            const end = new Date(formValues.endDate);
            if (start > end) return true;
        }
    } catch {
        // ignore parse errors
    }

    return false;
};
